<template>
  <section>
    <div class="role">
      <div class="roleRight">
        <div class="roleRight_Top" style="display: block">
          <template v-if="searchShow">
            <el-input
                clearable
                v-model="search.searchKey"
                clas="input_search"
                placeholder="搜索关键字"
                @keyup.enter.native="getserviceList"
                style="margin-right: 10px"
            ></el-input>
            <el-select
                v-model="search.payStatus"
                clearable
                filterable
                placeholder="支付状态"
            >
              <el-option
                  v-for="item in PAY_STATUS"
                  :key="item.key"
                  :label="item.name"
                  :value="item.key"
              ></el-option>
            </el-select>
            <el-select
                v-model="search.paymentType"
                clearable
                filterable
                placeholder="支付方式"
            >
              <el-option
                  v-for="item in PAYMENT_TYPE"
                  :key="item.type"
                  :label="item.name"
                  :value="item.type"
              ></el-option>
            </el-select>
            <el-select
                v-model="search.appInfoId"
                clearable
                filterable
                placeholder="下单应用"
            >
              <el-option
                  v-for="item in appList"
                  :key="item.appInfoId"
                  :label="item.appName"
                  :value="item.appInfoId"
              ></el-option>
            </el-select>
            <div class="block timeblock" style="margin-bottom: 10px;display: inline-block;margin-right: 10px;">
              <el-select
                  v-model="search.timeType"
                  clearable
                  placeholder="选择时间"
                  class='xq_time_select'
                  style="margin: 0;display: inline-block"
              >
                <el-option
                    v-for="item in TIME_TYPE"
                    :key="item.key"
                    :label="item.name"
                    :value="item.key"
                ></el-option>
              </el-select>
              <el-date-picker
                  style="display: inline-block;padding: 0"
                  v-model="value2"
                  type="datetimerange"
                  :picker-options="pickerOptions"
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  align="right"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  class='xq_time_picker'
              >
              </el-date-picker>
            </div>

            <el-button size="medium" type="primary" @click="getserviceList(1)"
            >查询
            </el-button
            >
          </template>
          <el-button v-if="downShow" size="medium" type="primary" @click="upserviceList"
          >下载
          </el-button
          >
        </div>
        <div class="roleRight_Container public-table-data">
          <el-table
              :data="tableData"
              size="medium"
              border
              style="width: 100%"
              row-key="customerServiceId"
              v-loading="loading"
          >
            <el-table-column fixed label="序号" type="index" width="50">
              <template slot-scope="scope">
                <span>{{scope.$index + 1}}</span>
              </template>
            </el-table-column>
            <el-table-column prop="orderTitle" label="订单名称 / SKU名称" min-width="260"></el-table-column>
            <el-table-column prop="orderNumber" label="订单号" min-width="200">
            </el-table-column>
            <el-table-column prop="orderMoney" label="订单金额" min-width="100">
              <template slot-scope="scope">
                $ {{ scope.row.orderMoney }}
              </template>
            </el-table-column>
            <el-table-column prop="payMoney" label="支付金额" min-width="100">
              <template slot-scope="scope">
                $ {{ scope.row.payMoney }}
              </template>
            </el-table-column>
            <el-table-column prop="email" label="用户邮箱" min-width="200">
            </el-table-column>
            <el-table-column prop="ctime" label="下单时间" min-width="180"></el-table-column>
            <el-table-column prop="payTime" label="支付时间" min-width="180"></el-table-column>
            <el-table-column fixed="right" label="操作" width="100">
              <template slot-scope="scope">
                <div class="button_code">
                  <el-button
                      v-if="detailShow"
                      @click="getOrderDetail(scope.row)"
                      size="small"
                  >详情
                  </el-button
                  >
                  <el-popover
                      trigger="hover"
                      placement="bottom"
                      width="150px"
                      v-if="qrcodeShow && scope.row.examPostId != 0 && scope.row.examPostId"
                  >
                    <template>
                      <app-qr-code :text="'http://exl.xyunxin.com/report/content-'+scope.row.orderNumber"
                              :correctLevel="3"
                              :size="100"
                              :margin="10"
                              colorDark="#000000"
                              colorLight="white"
                              backgroundColor="white"
                              backgroundDimming="white"
                              :logoSrc="require('../../assets/images/taotanlogo_back.png')"
                              :logoScale=".2"
                              :logoMargin="5"
                              logoBackgroundColor="white"
                      ></app-qr-code>
                    </template>
                    <span
                        slot="reference"
                        class="name-wrapper"
                    >
                    <img src="../../assets/images/code.png">
                  </span>
                  </el-popover>
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="roleRight_pagenation">
          <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="page.pageNo"
              :page-sizes="[PAGE_SIZE, 15, 20, 25]"
              :page-size="page.pageSize"
              layout="total, sizes, prev, pager, next, jumper"
              :total="page.count"
          >
          </el-pagination>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import {
  PAGE_SIZE,
  PAY_STATUS,
  PAYMENT_TYPE,
  NEWUSER_ORDER,
  TIME_TYPE,
} from "@/config";

import {isEmpty} from "@utils/tools/index";
import AppQrCode from "@/components/AppQrCode";

export default {
  components: {
    AppQrCode
  },
  data() {
    return {
      qrcodeText: "舒工请你付款来了", //二维码内容（扫码识别后需要访问的网址）
      amount: 168,//金额
      PAGE_SIZE,
      PAY_STATUS,
      PAYMENT_TYPE,
      NEWUSER_ORDER,
      TIME_TYPE,
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
      isEmpty,//需要在此初始化才可以在页面使用
      value2: "", //以上时间选择器
      enumCode: "PUT_WAY",
      touFangList: [], //渠道用户投放方式
      categoryList: [], //测评题分类数组
      dictDataSelect: "", //测评题tree点击后显示
      treeProps: {
        //测评题 配置选项:此处定义el-tree的label和children为指定属性，  如果不定义取默认，即label和children
        children: "examCategoryVos",
        label: "name",
      },
      channelList: [], //渠道类型list
      appList: [], //归属应用appid
      // 分页
      page: {
        pageNo: 1,
        pageSize: PAGE_SIZE,
      },
      tableData: [], //顶顶那列表
      loading: false,
      search: {},
      clickType: "", //弹窗类型
      params: {}, //弹窗修改数据
      searchShow: false,
      downShow: false,
      detailShow: false,
      qrcodeShow: false,

    };
  },
  mounted() {
    this.getAppList();
    // this.getChannelList();
    // this.gettouFangList();
    // this.getCategoryList();
    this.getserviceList();
    this.getPermissionButtonList()
  },
  watch: {
    dialogVisible() {
      if (this.dialogVisible == false) {
        this.$refs["ruleForm"].resetFields();
        this.params = {};
      }
    },
  },
  methods: {
    getPermissionButtonList() {
      let PermissionButtonList = window.sessionStorage.getItem('TaotanPermissionButton')
      let arr = JSON.parse(PermissionButtonList)
      if (arr.length) {
        arr.map(item => {
          if (item.code == 'guo:order:exam:query') {
            this.searchShow = true
          }
          if (item.code == 'guo:order:exam:down') {
            this.downShow = true
          }
          if (item.code == "guo:order:exam:detail") {
            this.detailShow = true
          }
          if (item.code == "guo:order:exam:detail:qrcode") {
            this.qrcodeShow = true
          }
        })
      }
    },

    goShowReport(item) {
      let url = 'http://exl.xyunxin.com/report/content-' + item.orderNumber
      window.open(url)
    },
    //获取归属应用
    async getAppList() {
      const {data: orgData} = await this.$get(`/app/list?paging=false&appType=WEBSIT`);
      this.appList = orgData.data;
    },
    //获取渠道账号
    async getChannelList() {
      const {data: orgData} = await this.$get(`/channel/account/list?paging=false`);
      this.channelList = orgData.data;
    },
    // 获取渠道用户投放方式
    async gettouFangList() {
      const {data: orgData} = await this.$get(`/enums/list/${this.enumCode}`);
      this.touFangList = orgData.data;
    },
    //get categoryList:[],//测评题分类数组
    async getCategoryList() {
      const {data: res} = await this.$get(`/exam/category/list?tree=true`, {
        headers: {
          isLoading: true,
        },
      });
      this.categoryList = res.data;
    },
    // 下载事件
    async upserviceList() {
      if (this.value2 && this.value2.length) {
        if (this.search.timeType == undefined || this.search.timeType == '') {
          this.$message.warning("请先选择筛选时间类型");
          return;
        }
        this.search.startTime = this.value2[0];
        this.search.endTime = this.value2[1];
      }
      if (this.search.timeType) {
        if (this.value2 == undefined || this.value2 == "") {
          this.$message.warning("请选择起止时间");
          return;
        }
      }
      let obj = this.search
      let startTime = obj.startTime ? obj.startTime : ''
      let endTime = obj.endTime ? obj.endTime : ''
      if (startTime && endTime) {
        const {data: res} = await this.$get(
            `/exam/order/export/create`,
            {params: {...this.search}},
            {
              headers: {
                // isLoading: true,
              },
            }
        );
        this.$message.success(res.data)
      } else {
        this.$message.warning('请选择时间')
      }
    },
    //订单列表
    async getserviceList(e) {
      if (e == 1) {
        this.page.pageNo = 1;
      }
      if (this.value2 && this.value2.length) {
        if (this.search.timeType == undefined || this.search.timeType == '') {
          this.$message.warning("请先选择筛选时间类型");
          return;
        }
        this.search.startTime = this.value2[0];
        this.search.endTime = this.value2[1];
      }
      if (this.search.timeType) {
        if (this.value2 == undefined || this.value2 == "") {
          this.$message.warning("请选择起止时间");
          return;
        }
      }
      this.loading = true;
      const {data: res} = await this.$get(
          `/extra/order/list`,
          {params: {...this.search, ...this.page}},
          {
            headers: {
              isLoading: true,
            },
          }
      );
      this.loading = false;
      let list = res.data
      if (list) {
        list.forEach((item) => {
          item.orderMoney = item.orderMoney / 100
          item.payMoney = item.payMoney / 100
        })
      }
      this.tableData = list;
      this.page.count = res.page.count;
    },
    //订单详情
    getOrderDetail(row) {
      this.$router.push({
        name: 'INTERNATIONAL_DETAIL_PAGE',
        query: {
          id: 0,
          title: '测评订单',
          key: 'orderNumber',
          value: JSON.stringify(row.orderNumber),
          path: '/extra/order/info',
        }
      })
    },
    //分页
    handleSizeChange(val) {
      this.page.pageSize = val;
      this.getserviceList();
    },
    handleCurrentChange(val) {
      this.page.pageNo = val;
      this.getserviceList();
    },
  },
};
</script>

<style lang="scss" scoped>
.role {
  display: flex;
  gap: 20px;
  color: #666; /** 公共的黑色 --暂定 */
  font-size: 14px;

  &Right {
    flex: 1;
    display: flex;
    flex-direction: column;
    overflow-x: hidden;

    &_Top {
      display: flex;
      gap: 15px;

      .el-input {
        width: auto;
      }

      .timeblock {
        display: flex;
        box-sizing: border-box;
        background: #fff;
        border: 1px solid #dcdfe6;
        border-radius: 5px;

        .cla ::v-deep .el-input--suffix .el-input__inner {
          padding-right: 0;
        }

        ::v-deep .el-input__inner {
          border: none !important;
          height: 38px;
        }
      }
    }

    &_Container {
      margin-top: 20px;
    }

    &_pagenation {
      margin: 40px auto;
    }

    ::v-deep .el-table th,
    ::v-deep .el-table td {
      text-align: center !important;
    }
  }
}

.el-select {
  margin-bottom: 10px;
  margin-right: 10px;
}

.name-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  margin-left: 10px;

  img {
    width: 25px;
    height: 25px;
  }
}

.button_code {
  display: flex;
  align-items: center;
  justify-content: center;

  .el-button--small, .el-button--small.is-round {
    padding: 11px 15px !important;
  }
}
</style>
